///? Default IMPORTS

import React, { Component } from "react";
import { connect } from "react-redux";

///? Service IMPORTS
import { logisticDashboardThunk } from "../../../redux/LogisticDashboardRedux/Action";

///? Component & Styling IMPORTS
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import "react-day-picker/lib/style.css";
import {
  Divider,
  Input,
  message,
  Spin,
  Table,
  Button,
  Badge,
  Tag,
  Select,
  Modal,
  Popconfirm,
  Alert,
} from "antd";
// import ToggleWarehouse from "../../../components/WarehouseToggle/toggleWarehouse";
import { FiSearch } from "react-icons/fi";
import { GrDocumentCsv } from "react-icons/gr";
import {
  LogisticDashboardTable,
  LogisticDashboardWrapper,
} from "./Logistic.style";
import DashboardBox from "../../../components/DashboardBox/DashboardBox";
import { Base64func } from "../../../components/Base64Func/Base64func";
import { warehouseId } from "../../../constants";

///? Constants
message.config({
  maxCount: 1,
});

let disableSubmitBtnVar = false;

export class LogisticDashboard extends Component {
  state = {
    from: undefined,
    to: undefined,
    loaderSearch: false,
    statLocal: null,
    warehouseId: warehouseId,
    // selectedTags: ["All"],
    isLoaded: false,
    bluedartExpressData: [],
    delhiveryAirData: [],
    bluedartData: [],
    weFastData: [],
    delhiveryData: [],
    handData: [],
    expressData: [],
  };

  componentDidMount() {
    window.onbeforeunload = function () {
      if (disableSubmitBtnVar) {
        return "Data will be lost if you leave the page, are you sure?";
      }
    };

    // let { warehouseId, selectedTags } = this.state;
    // if (this.props.userDto) {
    //   if (this.props.userType) {
    //     warehouseId = [0];
    //     selectedTags = ["All"];
    //   } else {
    //     warehouseId = [this.props.userDto.warehouseIdList[0]];
    //     selectedTags = this.props.warehouseList[warehouseId]["warehouseName"];
    //   }
    // }

    this.setState(
      {
        // warehouseId,
        // selectedTags,
        isLoaded: true,
        from: this.getStartDate(new Date()),
        to: new Date(),
      },
      () => {
        // this.getLogisticData();
      }
    );
  }

  getStartDate = (date) => {
    date.setDate(date.getDate() - 2);
    return date;
  };

  // handleWareHouseChange = (data) => {
  //   this.setState(
  //     {
  //       selectedTags: data.selectedTags,
  //       warehouseId: [data.warehouseId],
  //       isLoaded: false,
  //     },
  //     () => {
  //       this.getLogisticData();
  //     }
  //   );
  // };

  handleFromChange = (from) => {
    this.setState({ from });
  };
  handleToChange = (to) => {
    this.setState({ to }, this.showFromMonth);
  };
  showFromMonth = () => {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), "months") < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  };
  DateFormatter = (param) => {
    let result =
      this.state[param].getFullYear() +
      "-" +
      (this.state[param].getMonth() + 1) +
      "-" +
      this.state[param].getDate();
    return result;
  };

  getLogisticData = (value) => {
    disableSubmitBtnVar = true;
    this.setState({ isLoaded: false });
    message.loading("Loading Data..., Please Wait!", 0);
    let { from, to } = this.state;
    let { userDto } = this.props;
    // let { warehouseId } = this.state;
    if (from && to) {
      this.setState({ loaderSearch: true });
      let fromRefined = this.DateFormatter("from");
      let toRefined = this.DateFormatter("to");
      let propsData = {
        access_token: this.props.access_token,
        fromDate: fromRefined + " 00:00:01",
        toDate: toRefined + " 23:59:59",
        history: this.props.history,
        isExportCsv: value ? true : false,
      };

      let data = [warehouseId];

      setTimeout(() => {
        if (!this.state.isLoaded) {
          message.loading(
            "This page is taking longer to load than usual, please wait!",
            0
          );
        }
      }, 5000);

      this.props.logisticDashboardThunk(propsData, data).then(() => {
        disableSubmitBtnVar = false;
        message.destroy();
        if (this.props?.stat?.logisticDashboardError) {
          message.error(
            this.props?.stat?.logisticDashboardError
              ? this.props?.stat?.logisticDashboardError
              : "Something went wrong"
          );
          this.setState({
            loaderSearch: false,
            isLoaded: true,
            statLocal: null,
          });
        } else {
          message.success("Data successfully loaded");

          this.setState(
            {
              loaderSearch: false,
              statLocal: this.props?.stat?.logisticDashboardData,
              isLoaded: true,
            },
            () => {
              let { statLocal } = this.state;
              let LogisticData = [];

              statLocal.bluedartExpressDelivery &&
                LogisticData.push(statLocal.bluedartExpressDelivery);
              statLocal.delhiveryAirDelivery &&
                LogisticData.push(statLocal.delhiveryAirDelivery);
              statLocal.bluedartDelivery &&
                LogisticData.push(statLocal.bluedartDelivery);
              statLocal.weFastDelivery &&
                LogisticData.push(statLocal.weFastDelivery);
              statLocal.delhiveryDelivery &&
                LogisticData.push(statLocal.delhiveryDelivery);
              statLocal.handDelivery &&
                LogisticData.push(statLocal.handDelivery);
              statLocal.expressDelivery &&
                LogisticData.push(statLocal.expressDelivery);
              statLocal.selfDelivery &&
                LogisticData.push(statLocal.selfDelivery);
              statLocal.cabtDelivery &&
                LogisticData.push(statLocal.cabtDelivery);

              this.setState({
                logisticDashData: LogisticData,
              });

              if (value) {
                window.open(`${this.state.statLocal.filePath}`, "_blank");
              }
            }
          );
        }
      });
    } else {
      message.warn("Please select a date range");
      this.setState({ isLoaded: true, loaderSearch: false });
    }
  };

  exportCsvFunc = () => {
    this.getLogisticData(true);
  };

  ////? Table search filter
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          //  icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <FiSearch style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    //  render: (text) => (
    //    <Highlighter
    //      highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
    //      searchWords={[this.state.searchText]}
    //      autoEscape
    //      textToHighlight={text.toString()}
    //    />
    //  ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // - Ends //

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    const Column = [
      {
        title: "Order Assigned",
        dataIndex: "orderAssigned",
        key: "orderAssigned",
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Order Dispatched",
        dataIndex: "orderDispatched",
        key: "orderDispatched",
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Payment Pending",
        dataIndex: "paymentPending",
        key: "paymentPending",
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Pending for Dispatch",
        dataIndex: "pendingForDispatch",
        key: "pendingForDispatch",
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Order Delivered",
        dataIndex: "orderDelivered",
        key: "orderDelivered",
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Order Cancelled",
        dataIndex: "orderCancelled",
        key: "orderCancelled",
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
    ];
    return (
      <>
        <LogisticDashboardWrapper>
          <div className="DateSelect">
            <DayPickerInput
              value={from}
              placeholder="From"
              format="DD/MM/YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [from, { from, to }],
                disabledDays: { after: to },
                toMonth: to,
                modifiers,
                numberOfMonths: 2,
                onDayClick: () => this.to.getInput().focus(),
              }}
              onDayChange={this.handleFromChange}
            />

            <DayPickerInput
              ref={(el) => (this.to = el)}
              value={to}
              placeholder="To"
              format="DD/MM/YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [from, { from, to }],
                disabledDays: { before: from },
                modifiers,
                month: from,
                fromMonth: from,
                numberOfMonths: 2,
              }}
              onDayChange={this.handleToChange}
            />
            <button
              className="bbtn"
              onClick={() => {
                this.getLogisticData();
              }}
              // disabled={!this.state.from || !this.state.to}
              disabled={!this.state.isLoaded}
            >
              Search
            </button>
          </div>

          <button
            className="bbtn"
            style={{ width: "max-content" }}
            disabled={!this.state.statLocal || !this.state.isLoaded}
            onClick={this.exportCsvFunc}
          >
            Export CSV <GrDocumentCsv />
          </button>

          {/* {this.props.userType ? (
            <ToggleWarehouse
              handleWareHouseChange={(data) => this.handleWareHouseChange(data)}
              selectedTags={this.state.selectedTags}
              warehouseId={this.state.warehouseId}
              userDto={this.props.userDto}
              warehouseList={this.props.warehouseList}
              isLoaded={this.state.isLoaded}
            />
          ) : (
            ""
          )} */}
        </LogisticDashboardWrapper>

        <LogisticDashboardTable>
          {this.state.statLocal && (
            <Spin spinning={!this.state.isLoaded}>
              {this.state.logisticDashData?.map((i, p) => (
                <div key={p} className="logiTable">
                  <Badge.Ribbon text={i.courierPartner} placement="start">
                    <Table
                      dataSource={[i]}
                      columns={Column}
                      loading={!this.state.isLoaded}
                      pagination={false}
                      bordered
                      scroll={{ x: 700 }}
                    />
                  </Badge.Ribbon>
                </div>
              ))}
            </Spin>
          )}
        </LogisticDashboardTable>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  stat: state.logisticDashReducer,
  userDto: state.authReducer?.AuthData?.userDTO,
  userType: state.authReducer?.userType,
  warehouseList: state.authReducer?.AuthData?.warehouseList,
});

const mapDispatchToProps = { logisticDashboardThunk };

export default connect(mapStateToProps, mapDispatchToProps)(LogisticDashboard);
